import { SupportedLocation } from "./types";

export const US_LOCATIONS: SupportedLocation[] = [
  // ALABAMA
  {
    id: "us-al-montgomery",
    cityName: "Montgomery",
    stateName: "Alabama",
    stateAbbreviation: "AL",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "alabama",
    citySlug: "montgomery-al",
    lat: 32.3792,
    lng: -86.3077,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 310,
    relevantCategoryCount: 20,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["birmingham-al", "huntsville-al", "mobile-al"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Montgomery Metropolitan Area (Capitol Hill & Maxwell AFB Corridor)",
      localContextText: "Alabama's state capital features a prominent public administration, legal consulting, defense IT, and regional healthcare footprint.",
      majorDistricts: [
        { name: "Downtown Capitol Complex", desc: "State administrative law offices, legislative affairs, lobbying practices, and accounting." },
        { name: "Maxwell Air Force Base Technology Corridor", desc: "Defense IT contractors, cybersecurity advisories, and aerospace software." }
      ],
      topSectors: [
        { title: "Legal & Public Policy Services", desc: "Administrative law offices, regulatory compliance, and tax accounting." },
        { title: "Defense Technology & IT Support", desc: "Federal software contractors, cybersecurity, and network administration." }
      ],
      majorInstitutions: ["Alabama State University", "Auburn University at Montgomery (AUM)"]
    }
  },
  {
    id: "us-al-birmingham",
    cityName: "Birmingham",
    stateName: "Alabama",
    stateAbbreviation: "AL",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "alabama",
    citySlug: "birmingham-al",
    lat: 33.5186,
    lng: -86.8104,
    supportedRadius: 25,
    dataCoverageScore: 94,
    businessCount: 780,
    relevantCategoryCount: 27,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["montgomery-al", "huntsville-al"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Birmingham-Hoover Metro Area (Financial Core, UAB Medical District)",
      localContextText: "The commercial and banking hub of Alabama, driven by medical research at UAB, financial services, engineering, and steel fabrication.",
      majorDistricts: [
        { name: "UAB Medical District & Innovation Depot", desc: "Outpatient clinical research, biotech incubators, medical devices, and health tech." },
        { name: "Downtown Financial & Legal Core", desc: "Corporate banking, litigation law practices, insurance advisories, and accounting." }
      ],
      topSectors: [
        { title: "Healthcare & Biotech Innovation", desc: "Specialty medical clinics, physical therapy networks, and diagnostic laboratories." },
        { title: "Banking & Legal Services", desc: "Wealth management, corporate tax accounting, and commercial law." }
      ],
      majorInstitutions: ["University of Alabama at Birmingham (UAB)", "Samford University"]
    }
  },
  {
    id: "us-al-huntsville",
    cityName: "Huntsville",
    stateName: "Alabama",
    stateAbbreviation: "AL",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "alabama",
    citySlug: "huntsville-al",
    lat: 34.7304,
    lng: -86.5861,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 820,
    relevantCategoryCount: 28,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["birmingham-al", "nashville-tn"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Huntsville Metro Area (Cummings Research Park & Redstone Arsenal)",
      localContextText: "Known as Rocket City, Huntsville is home to America's second largest research park (Cummings Research Park), specializing in aerospace engineering, defense tech, and biotechnology.",
      majorDistricts: [
        { name: "Cummings Research Park", desc: "Aerospace propulsion labs, missile defense software, systems engineering, and biotech." }
      ],
      topSectors: [
        { title: "Aerospace & Systems Engineering", desc: "Avionics design, propulsion software, modeling and simulation, and defense." }
      ],
      majorInstitutions: ["The University of Alabama in Huntsville (UAH)"]
    }
  },

  // ALASKA
  {
    id: "us-ak-juneau",
    cityName: "Juneau",
    stateName: "Alaska",
    stateAbbreviation: "AK",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "alaska",
    citySlug: "juneau-ak",
    lat: 58.3019,
    lng: -134.4197,
    supportedRadius: 15,
    dataCoverageScore: 86,
    businessCount: 170,
    relevantCategoryCount: 15,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["anchorage-ak"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Juneau Capital City Region",
      localContextText: "Alaska's state capital center for public administration, marine science, fisheries tech, and cold-climate trades.",
      majorDistricts: [
        { name: "Capitol Complex & Downtown Juneau", desc: "Legislative affairs, environmental law consultancies, administrative services, and accounting." }
      ],
      topSectors: [
        { title: "Fisheries Science & Marine Technology", desc: "Aquaculture research, marine environmental testing, and vessel servicing." }
      ],
      majorInstitutions: ["University of Alaska Southeast (UAS)"]
    }
  },
  {
    id: "us-ak-anchorage",
    cityName: "Anchorage",
    stateName: "Alaska",
    stateAbbreviation: "AK",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "alaska",
    citySlug: "anchorage-ak",
    lat: 61.2181,
    lng: -149.9003,
    supportedRadius: 25,
    dataCoverageScore: 92,
    businessCount: 520,
    relevantCategoryCount: 23,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["juneau-ak"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Anchorage Metropolitan Area & Ted Stevens Cargo Airport",
      localContextText: "Alaska's largest city and primary global air cargo hub, supporting energy engineering, cold-climate logistics, medical care, and regional trade.",
      majorDistricts: [
        { name: "Downtown Commercial & Energy Core", desc: "Natural resource law, environmental consultancies, accounting practices, and engineering." }
      ],
      topSectors: [
        { title: "Air Logistics & Supply Chain", desc: "Cross-continental cargo transport, fleet mechanical servicing, and customs." }
      ],
      majorInstitutions: ["University of Alaska Anchorage (UAA)"]
    }
  },

  // ARIZONA
  {
    id: "us-az-phoenix",
    cityName: "Phoenix",
    stateName: "Arizona",
    stateAbbreviation: "AZ",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "arizona",
    citySlug: "phoenix-az",
    lat: 33.4484,
    lng: -112.074,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1680,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["scottsdale-az", "tempe-az", "tucson-az"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Phoenix Metropolitan Area (Biltmore, Camelback Corridor, Deer Valley)",
      localContextText: "Arizona's state capital and economic capital is a national powerhouse for semiconductor manufacturing (TSMC, Intel), healthcare systems, software engineering, and trade construction.",
      majorDistricts: [
        { name: "Deer Valley Silicon Desert Belt", desc: "Semiconductor fabrication, microchip testing, industrial automation, and trade contractors." }
      ],
      topSectors: [
        { title: "Semiconductor Manufacturing & Automation", desc: "Cleanroom engineering, precision tooling, electrical contractors, and HVAC." }
      ],
      majorInstitutions: ["Arizona State University (ASU)"]
    }
  },
  {
    id: "us-az-tucson",
    cityName: "Tucson",
    stateName: "Arizona",
    stateAbbreviation: "AZ",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "arizona",
    citySlug: "tucson-az",
    lat: 32.2226,
    lng: -110.9747,
    supportedRadius: 25,
    dataCoverageScore: 94,
    businessCount: 810,
    relevantCategoryCount: 28,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["phoenix-az"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Tucson Metro Area & Optics Valley",
      localContextText: "Home to Optics Valley, Tucson leads the Southwest in optical science, defense technology (Raytheon), astronomy, and solar energy research.",
      majorDistricts: [
        { name: "UA Tech Park & Optics Valley Corridor", desc: "Laser systems testing, optical software engineering, solar tech, and defense contractors." }
      ],
      topSectors: [
        { title: "Optics & Defense Engineering", desc: "Photonics labs, missile defense software, and optical component manufacturing." }
      ],
      majorInstitutions: ["University of Arizona (U of A)"]
    }
  },

  // ARKANSAS
  {
    id: "us-ar-little-rock",
    cityName: "Little Rock",
    stateName: "Arkansas",
    stateAbbreviation: "AR",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "arkansas",
    citySlug: "little-rock-ar",
    lat: 34.7465,
    lng: -92.2896,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 490,
    relevantCategoryCount: 22,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["fayetteville-ar", "memphis-tn"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Little Rock Capital Region & UAMS Medical District",
      localContextText: "Arkansas' capital is a regional healthcare, legal, state government relations, and financial services center.",
      majorDistricts: [
        { name: "UAMS BioVentures & Healthcare District", desc: "Outpatient medical research, orthopedic care, diagnostic labs, and specialty practices." }
      ],
      topSectors: [
        { title: "Healthcare & Outpatient Care", desc: "Specialized medical clinics, physical therapy, and dental practices." }
      ],
      majorInstitutions: ["University of Arkansas for Medical Sciences (UAMS)"]
    }
  },

  // CALIFORNIA
  {
    id: "us-ca-sacramento",
    cityName: "Sacramento",
    stateName: "California",
    stateAbbreviation: "CA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "california",
    citySlug: "sacramento-ca",
    lat: 38.5816,
    lng: -121.4944,
    supportedRadius: 25,
    dataCoverageScore: 96,
    businessCount: 1150,
    relevantCategoryCount: 31,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["san-francisco-ca", "san-jose-ca", "oakland-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Sacramento Metropolitan Area (Capitol Mall, Roseville)",
      localContextText: "California's state capital anchors a vast public policy, environmental law, clean technology, health tech (UC Davis Health), and agtech economy.",
      majorDistricts: [
        { name: "Capitol Mall & Downtown Legal Core", desc: "Environmental law practices, state regulatory consultancies, public affairs, and accounting." }
      ],
      topSectors: [
        { title: "Environmental & Administrative Law", desc: "Regulatory compliance advisories, environmental law offices, and public affairs." }
      ],
      majorInstitutions: ["California State University Sacramento"]
    }
  },
  {
    id: "us-ca-los-angeles",
    cityName: "Los Angeles",
    stateName: "California",
    stateAbbreviation: "CA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "california",
    citySlug: "los-angeles-ca",
    lat: 34.0522,
    lng: -118.2437,
    supportedRadius: 30,
    dataCoverageScore: 99,
    businessCount: 1850,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["san-diego-ca", "pasadena-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Los Angeles (Downtown Core, Silicon Beach, Century City)",
      localContextText: "A massive multi-industry powerhouse spanning entertainment technology, aerospace (El Segundo), digital media, apparel manufacturing, commercial trades, and specialized medicine.",
      majorDistricts: [
        { name: "Silicon Beach (Playa Vista & Santa Monica)", desc: "Ad tech, game development, mobile software, and digital media production." }
      ],
      topSectors: [
        { title: "Entertainment Law & Media Tech", desc: "Intellectual property practices, streaming tech, and post-production studios." }
      ],
      majorInstitutions: ["UCLA", "USC"]
    }
  },
  {
    id: "us-ca-san-francisco",
    cityName: "San Francisco",
    stateName: "California",
    stateAbbreviation: "CA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "california",
    citySlug: "san-francisco-ca",
    lat: 37.7749,
    lng: -122.4194,
    supportedRadius: 25,
    dataCoverageScore: 99,
    businessCount: 1820,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["san-jose-ca", "sacramento-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "San Francisco Bay Area (SoMa Tech, Financial District, Mission Bay)",
      localContextText: "Global tech innovation hub leading in Generative AI, cloud computing software, venture capital, biotech, and fintech.",
      majorDistricts: [
        { name: "SoMa & South Beach AI Corridor", desc: "AI research labs, venture capital firms, SaaS consultancies, and UX design." }
      ],
      topSectors: [
        { title: "Generative AI & Enterprise SaaS", desc: "LLM engineering, cloud infrastructure, developer platforms, and analytics." }
      ],
      majorInstitutions: ["UCSF", "SFSU"]
    }
  },

  // COLORADO
  {
    id: "us-co-denver",
    cityName: "Denver",
    stateName: "Colorado",
    stateAbbreviation: "CO",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "colorado",
    citySlug: "denver-co",
    lat: 39.7392,
    lng: -104.9903,
    supportedRadius: 30,
    dataCoverageScore: 97,
    businessCount: 1480,
    relevantCategoryCount: 33,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["boulder-co", "colorado-springs-co"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Denver Metropolitan Area (RiNo Tech, Tech Center DTC)",
      localContextText: "Colorado's state capital leads the Mountain West in software technology, aerospace, clean energy engineering, telecommunications, and sports medicine.",
      majorDistricts: [
        { name: "RiNo Art District Tech Core", desc: "Custom software shops, digital marketing agencies, architectural practices, and design." }
      ],
      topSectors: [
        { title: "Software Engineering & Telecommunications", desc: "SaaS platforms, cloud security, network architecture, and mobile apps." }
      ],
      majorInstitutions: ["University of Denver (DU)"]
    }
  },

  // CONNECTICUT
  {
    id: "us-ct-hartford",
    cityName: "Hartford",
    stateName: "Connecticut",
    stateAbbreviation: "CT",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "connecticut",
    citySlug: "hartford-ct",
    lat: 41.7658,
    lng: -72.6734,
    supportedRadius: 20,
    dataCoverageScore: 93,
    businessCount: 520,
    relevantCategoryCount: 23,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["bridgeport-ct", "boston-ma"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Hartford Insurance & Aerospace Core",
      localContextText: "Connecticut's state capital, known as the Insurance Capital of the World, driven by actuarial science, insurtech, aerospace engineering (Pratt & Whitney), and healthcare.",
      majorDistricts: [
        { name: "Downtown Insurance & Financial District", desc: "Insurtech software engineering, underwriting advisories, risk analysis, and corporate law." }
      ],
      topSectors: [
        { title: "Insurance & Actuarial Software", desc: "Insurtech platforms, risk management, and financial advisories." }
      ],
      majorInstitutions: ["University of Hartford", "Trinity College"]
    }
  },

  // DELAWARE
  {
    id: "us-de-dover",
    cityName: "Dover",
    stateName: "Delaware",
    stateAbbreviation: "DE",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "delaware",
    citySlug: "dover-de",
    lat: 39.1582,
    lng: -75.5244,
    supportedRadius: 15,
    dataCoverageScore: 89,
    businessCount: 280,
    relevantCategoryCount: 18,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["wilmington-de", "philadelphia-pa"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Dover Capital Region & Kent County",
      localContextText: "Delaware's state capital center for corporate incorporation legal services, state administration, defense technology (Dover AFB), and agriculture.",
      majorDistricts: [
        { name: "State Capitol & Corporate Legal Belt", desc: "Corporate filing advisories, administrative law, public policy, and tax law." }
      ],
      topSectors: [
        { title: "Corporate Incorporation & Legal Services", desc: "Delaware corporate law, entity structure consultancies, and tax compliance." }
      ],
      majorInstitutions: ["Delaware State University"]
    }
  },

  // FLORIDA
  {
    id: "us-fl-tallahassee",
    cityName: "Tallahassee",
    stateName: "Florida",
    stateAbbreviation: "FL",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "florida",
    citySlug: "tallahassee-fl",
    lat: 30.4383,
    lng: -84.2807,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 410,
    relevantCategoryCount: 21,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["miami-fl", "orlando-fl"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Tallahassee Capital Region & Innovation Park",
      localContextText: "Florida's state capital focuses on state administrative law, public policy consultancies, high-magnetic-field physics research, and higher education.",
      majorDistricts: [
        { name: "Downtown Capitol Complex", desc: "Administrative law offices, legislative consulting, lobbying firms, and accounting." }
      ],
      topSectors: [
        { title: "Administrative & Regulatory Law", desc: "Government compliance practices, public policy advisories, and tax accounting." }
      ],
      majorInstitutions: ["Florida State University (FSU)"]
    }
  },
  {
    id: "us-fl-miami",
    cityName: "Miami",
    stateName: "Florida",
    stateAbbreviation: "FL",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "florida",
    citySlug: "miami-fl",
    lat: 25.7617,
    lng: -80.1918,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1720,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["tallahassee-fl", "orlando-fl"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Miami Area (Brickell Financial, Wynwood Tech)",
      localContextText: "The Gateway to the Americas is a major hub for cross-border private banking, fintech, healthcare, hospitality design, and international law.",
      majorDistricts: [
        { name: "Brickell Financial District", desc: "Private banking, international trade law, hedge funds, and corporate tax accounting." }
      ],
      topSectors: [
        { title: "Cross-Border Law & Financial Services", desc: "International tax advisories, trade law practices, and wealth management." }
      ],
      majorInstitutions: ["University of Miami (UM)"]
    }
  },

  // GEORGIA
  {
    id: "us-ga-atlanta",
    cityName: "Atlanta",
    stateName: "Georgia",
    stateAbbreviation: "GA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "georgia",
    citySlug: "atlanta-ga",
    lat: 33.749,
    lng: -84.388,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1690,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["savannah-ga"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Metro Atlanta (Midtown Tech, Buckhead Financial)",
      localContextText: "The capital of the American South leads in Transaction Alley fintech, health IT, logistics software, music/film production, and corporate law.",
      majorDistricts: [
        { name: "Midtown & Tech Square", desc: "Software engineering shops, AI research labs, cybersecurity, and fintech." }
      ],
      topSectors: [
        { title: "Fintech & Transaction Processing", desc: "Payment processing software, security architecture, and mobile banking tech." }
      ],
      majorInstitutions: ["Georgia Institute of Technology (Georgia Tech)"]
    }
  },

  // HAWAII
  {
    id: "us-hi-honolulu",
    cityName: "Honolulu",
    stateName: "Hawaii",
    stateAbbreviation: "HI",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "hawaii",
    citySlug: "honolulu-hi",
    lat: 21.3069,
    lng: -157.8583,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 610,
    relevantCategoryCount: 24,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: [],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Honolulu Metropolitan Area (Kakaako Innovation District)",
      localContextText: "Hawaii's state capital center for Pacific Rim trade, marine biology, renewable energy research, military defense, and luxury hospitality tech.",
      majorDistricts: [
        { name: "Kakaako Tech & Innovation District", desc: "Ocean science labs, clean energy tech, software design, and marine engineering." }
      ],
      topSectors: [
        { title: "Clean Energy & Ocean Sciences", desc: "Solar microgrids, marine environmental engineering, and aquaculture research." }
      ],
      majorInstitutions: ["University of Hawaii at Manoa"]
    }
  },

  // IDAHO
  {
    id: "us-id-boise",
    cityName: "Boise",
    stateName: "Idaho",
    stateAbbreviation: "ID",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "idaho",
    citySlug: "boise-id",
    lat: 43.615,
    lng: -116.2023,
    supportedRadius: 25,
    dataCoverageScore: 94,
    businessCount: 680,
    relevantCategoryCount: 25,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["salt-lake-city-ut"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Boise-Nampa Metro Area & Micron Memory Belt",
      localContextText: "Idaho's state capital features semiconductor memory engineering (Micron Technology), agritech, outdoor technology, and enterprise software.",
      majorDistricts: [
        { name: "Micron Semiconductor Innovation Park", desc: "DRAM memory engineering, microchip packaging, cleanroom robotics, and materials labs." }
      ],
      topSectors: [
        { title: "Semiconductor Memory Engineering", desc: "Microelectronics, silicon fabrication, testing engineering, and automation." }
      ],
      majorInstitutions: ["Boise State University"]
    }
  },

  // ILLINOIS
  {
    id: "us-il-springfield",
    cityName: "Springfield",
    stateName: "Illinois",
    stateAbbreviation: "IL",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "illinois",
    citySlug: "springfield-il",
    lat: 39.7817,
    lng: -89.6501,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 380,
    relevantCategoryCount: 20,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["peoria-il", "chicago-il"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Springfield Capital Area & Medical District",
      localContextText: "Illinois state capital center for state legislative affairs, SIU School of Medicine, administrative law, and healthcare.",
      majorDistricts: [
        { name: "Capitol Complex & Legal Core", desc: "State administrative law, regulatory consulting, public affairs, and lobbying." }
      ],
      topSectors: [
        { title: "Public Policy & State Law", desc: "Legislative advisories, state compliance, and tax law." }
      ],
      majorInstitutions: ["University of Illinois Springfield (UIS)", "SIU School of Medicine"]
    }
  },
  {
    id: "us-il-peoria",
    cityName: "Peoria",
    stateName: "Illinois",
    stateAbbreviation: "IL",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "illinois",
    citySlug: "peoria-il",
    lat: 40.6936,
    lng: -89.589,
    supportedRadius: 25,
    dataCoverageScore: 98,
    businessCount: 420,
    relevantCategoryCount: 24,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["springfield-il", "chicago-il"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Peoria Metropolitan Area & Warehouse District",
      localContextText: "Peoria is a central Illinois healthcare, heavy engineering, and specialized trade manufacturing capital anchored by OSF HealthCare, Jump Simulation, and Caterpillar suppliers.",
      majorDistricts: [
        { name: "Downtown Medical District & Jump Simulation", desc: "Outpatient clinical research, surgical simulation, specialized pediatric medicine, and physical therapy." }
      ],
      topSectors: [
        { title: "Healthcare & Surgical Simulation", desc: "Private medical groups, dental practices, diagnostic labs, and medical technology." }
      ],
      majorInstitutions: ["Bradley University", "UIC Health Sciences Campus Peoria"]
    }
  },
  {
    id: "us-il-chicago",
    cityName: "Chicago",
    stateName: "Illinois",
    stateAbbreviation: "IL",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "illinois",
    citySlug: "chicago-il",
    lat: 41.8781,
    lng: -87.6298,
    supportedRadius: 30,
    dataCoverageScore: 99,
    businessCount: 1850,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["peoria-il", "springfield-il"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Chicago Metropolitan Area (Loop, Fulton Market)",
      localContextText: "As the Midwest's largest financial, legal, technology, and logistics center, Chicago offers thousands of unlisted opportunities in mid-sized firms, boutique agencies, law practices, and specialized medical clinics.",
      majorDistricts: [
        { name: "The Loop & Financial District", desc: "Financial advisory, corporate law practices, insurance brokerage firms, and commercial consulting agencies." }
      ],
      topSectors: [
        { title: "Financial & Professional Legal Services", desc: "Boutique law offices, CPA practices, wealth management advisories, and commercial consulting." }
      ],
      majorInstitutions: ["DePaul University", "UIC"]
    }
  },

  // INDIANA
  {
    id: "us-in-indianapolis",
    cityName: "Indianapolis",
    stateName: "Indiana",
    stateAbbreviation: "IN",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "indiana",
    citySlug: "indianapolis-in",
    lat: 39.7684,
    lng: -86.1581,
    supportedRadius: 25,
    dataCoverageScore: 96,
    businessCount: 1220,
    relevantCategoryCount: 32,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["chicago-il", "louisville-ky"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Indianapolis (16 Tech Innovation District, Wholesale District)",
      localContextText: "Indiana's state capital leads in pharmaceutical manufacturing (Eli Lilly), marketing cloud technology (Salesforce hub), logistics software, and motorsport engineering.",
      majorDistricts: [
        { name: "16 Tech Innovation District", desc: "Life sciences labs, bio-health engineering, health IT, and software incubators." }
      ],
      topSectors: [
        { title: "Life Sciences & Bio-Pharmaceuticals", desc: "Pharmaceutical formulation, diagnostic labs, clinical trial technology, and health IT." }
      ],
      majorInstitutions: ["IU Indianapolis (IUUI)", "Butler University"]
    }
  },

  // IOWA
  {
    id: "us-ia-des-moines",
    cityName: "Des Moines",
    stateName: "Iowa",
    stateAbbreviation: "IA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "iowa",
    citySlug: "des-moines-ia",
    lat: 41.5868,
    lng: -93.625,
    supportedRadius: 25,
    dataCoverageScore: 94,
    businessCount: 710,
    relevantCategoryCount: 26,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["omaha-ne", "chicago-il"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Des Moines & AgTech Innovation Zone",
      localContextText: "Iowa's state capital is a major insurance capital (Principal Financial), agtech research hub, and financial services center.",
      majorDistricts: [
        { name: "Downtown Financial & Insurance Belt", desc: "Annuity underwriting, wealth management, insurance law, and corporate accounting." }
      ],
      topSectors: [
        { title: "Insurance Tech & Financial Planning", desc: "Actuarial software, risk management, wealth advisories, and tax accounting." }
      ],
      majorInstitutions: ["Drake University"]
    }
  },

  // KANSAS
  {
    id: "us-ks-topeka",
    cityName: "Topeka",
    stateName: "Kansas",
    stateAbbreviation: "KS",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "kansas",
    citySlug: "topeka-ks",
    lat: 39.0558,
    lng: -95.689,
    supportedRadius: 20,
    dataCoverageScore: 90,
    businessCount: 380,
    relevantCategoryCount: 20,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["kansas-city-mo"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Topeka Capital Region & Animal Health Corridor",
      localContextText: "Kansas' state capital center for state government affairs, regulatory compliance, veterinary science, and logistics.",
      majorDistricts: [
        { name: "State Capitol Complex & Legal Core", desc: "Administrative law, public policy consultancies, legislative affairs, and accounting." }
      ],
      topSectors: [
        { title: "State Government Relations & Legal Services", desc: "Regulatory compliance, state taxation advisories, and corporate law." }
      ],
      majorInstitutions: ["Washburn University"]
    }
  },

  // KENTUCKY
  {
    id: "us-ky-frankfort",
    cityName: "Frankfort",
    stateName: "Kentucky",
    stateAbbreviation: "KY",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "kentucky",
    citySlug: "frankfort-ky",
    lat: 38.2009,
    lng: -84.8733,
    supportedRadius: 15,
    dataCoverageScore: 88,
    businessCount: 240,
    relevantCategoryCount: 17,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["lexington-ky", "louisville-ky"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Frankfort Capital Area & Bluegrass Region",
      localContextText: "Kentucky's state capital center for state administration, distilled spirits regulation, environmental law, and agriculture policy.",
      majorDistricts: [
        { name: "State Capitol & Legal District", desc: "Administrative compliance, regulatory law, state tax accounting, and public policy." }
      ],
      topSectors: [
        { title: "Public Policy & Distilled Spirits Law", desc: "Regulatory compliance, agricultural law, and administrative affairs." }
      ],
      majorInstitutions: ["Kentucky State University"]
    }
  },

  // LOUISIANA
  {
    id: "us-la-baton-rouge",
    cityName: "Baton Rouge",
    stateName: "Louisiana",
    stateAbbreviation: "LA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "louisiana",
    citySlug: "baton-rouge-la",
    lat: 30.4515,
    lng: -91.1871,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 580,
    relevantCategoryCount: 24,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["new-orleans-la"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Baton Rouge Capital Region & Chemical Corridor",
      localContextText: "Louisiana's state capital anchors chemical engineering, maritime logistics along the Mississippi, state legal affairs, and cancer research (Pennington Biomedical).",
      majorDistricts: [
        { name: "State Capitol & Downtown Legal Core", desc: "Environmental law, coastal restoration consultancies, administrative law, and accounting." }
      ],
      topSectors: [
        { title: "Chemical Engineering & Industrial Maintenance", desc: "Process engineering, environmental testing, electrical trades, and safety compliance." }
      ],
      majorInstitutions: ["Louisiana State University (LSU)", "Pennington Biomedical Research Center"]
    }
  },

  // MAINE
  {
    id: "us-me-augusta",
    cityName: "Augusta",
    stateName: "Maine",
    stateAbbreviation: "ME",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "maine",
    citySlug: "augusta-me",
    lat: 44.3106,
    lng: -69.7795,
    supportedRadius: 15,
    dataCoverageScore: 87,
    businessCount: 210,
    relevantCategoryCount: 16,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["portland-me", "boston-ma"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Augusta Capital Region & Kennebec Valley",
      localContextText: "Maine's state capital center for public policy, forestry environmental science, healthcare, and state administrative law.",
      majorDistricts: [
        { name: "State House & Capitol Complex", desc: "Administrative law, forestry compliance advisories, public policy, and tax accounting." }
      ],
      topSectors: [
        { title: "Forestry Science & Environmental Policy", desc: "Natural resource management, environmental law, and administrative compliance." }
      ],
      majorInstitutions: ["University of Maine at Augusta"]
    }
  },

  // MARYLAND
  {
    id: "us-md-annapolis",
    cityName: "Annapolis",
    stateName: "Maryland",
    stateAbbreviation: "MD",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "maryland",
    citySlug: "annapolis-md",
    lat: 38.9784,
    lng: -76.4922,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 460,
    relevantCategoryCount: 22,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["baltimore-md", "washington-dc"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Annapolis Capital Region & Chesapeake Bay Tech",
      localContextText: "Maryland's state capital specializes in maritime law, defense cyber research, naval engineering, and state government affairs.",
      majorDistricts: [
        { name: "Historic State House & Legal District", desc: "Maritime law practices, state regulatory affairs, public policy, and accounting." }
      ],
      topSectors: [
        { title: "Maritime Law & Cyber Defense", desc: "Naval architecture consultancies, cyber defense software, and coastal law." }
      ],
      majorInstitutions: ["United States Naval Academy (USNA)", "St. John's College"]
    }
  },

  // MASSACHUSETTS
  {
    id: "us-ma-boston",
    cityName: "Boston",
    stateName: "Massachusetts",
    stateAbbreviation: "MA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "massachusetts",
    citySlug: "boston-ma",
    lat: 42.3601,
    lng: -71.0589,
    supportedRadius: 30,
    dataCoverageScore: 99,
    businessCount: 1840,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["hartford-ct", "providence-ri"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Boston (Kendall Square BioTech, Seaport Financial)",
      localContextText: "Global biotech, robotics, higher education, and venture capital capital centered around Harvard, MIT, and Kendall Square.",
      majorDistricts: [
        { name: "Kendall Square BioTech Cluster", desc: "Gene therapy labs, oncology research, robotics software, and AI." }
      ],
      topSectors: [
        { title: "Biotechnology & Robotics Engineering", desc: "CRISPR gene editing labs, surgical robotics, and life science software." }
      ],
      majorInstitutions: ["Harvard University", "MIT", "Boston University (BU)", "Northeastern University"]
    }
  },

  // MICHIGAN
  {
    id: "us-mi-lansing",
    cityName: "Lansing",
    stateName: "Michigan",
    stateAbbreviation: "MI",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "michigan",
    citySlug: "lansing-mi",
    lat: 42.7325,
    lng: -84.5555,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 510,
    relevantCategoryCount: 23,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["detroit-mi", "grand-rapids-mi"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Lansing Capital Region & MSU Tech Zone",
      localContextText: "Michigan's state capital center for state legal affairs, automotive component engineering, insurance underwriting, and agricultural science at MSU.",
      majorDistricts: [
        { name: "Capitol Complex & Legal Core", desc: "Administrative law, regulatory consulting, insurance law, and accounting." }
      ],
      topSectors: [
        { title: "Public Administration & Insurance Law", desc: "State regulatory compliance, insurtech, and agricultural law." }
      ],
      majorInstitutions: ["Michigan State University (MSU)"]
    }
  },

  // MINNESOTA
  {
    id: "us-mn-st-paul",
    cityName: "St. Paul",
    stateName: "Minnesota",
    stateAbbreviation: "MN",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "minnesota",
    citySlug: "st-paul-mn",
    lat: 44.9537,
    lng: -93.09,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 880,
    relevantCategoryCount: 29,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["minneapolis-mn", "chicago-il"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Twin Cities Metropolitan Area (St. Paul Capital & Medical Alley)",
      localContextText: "Minnesota's state capital anchors Medical Alley (world's largest medical device cluster), materials engineering (3M), water tech (Ecolab), and state policy.",
      majorDistricts: [
        { name: "Capitol Hill & Downtown Legal Core", desc: "Administrative law, state regulatory affairs, lobbying, and public policy." }
      ],
      topSectors: [
        { title: "Medical Device Engineering & Materials Science", desc: "Catheter manufacturing, pacemaker tech, polymer materials, and health IT." }
      ],
      majorInstitutions: ["University of St. Thomas", "Macalester College"]
    }
  },

  // MISSISSIPPI
  {
    id: "us-ms-jackson",
    cityName: "Jackson",
    stateName: "Mississippi",
    stateAbbreviation: "MS",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "mississippi",
    citySlug: "jackson-ms",
    lat: 32.2988,
    lng: -90.1848,
    supportedRadius: 20,
    dataCoverageScore: 90,
    businessCount: 390,
    relevantCategoryCount: 21,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["baton-rouge-la", "memphis-tn"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Jackson Capital Region & UMMC Medical Complex",
      localContextText: "Mississippi's state capital center for state administration, healthcare research at UMMC, legal services, and regional banking.",
      majorDistricts: [
        { name: "UMMC Medical Center & Healthcare Corridor", desc: "Outpatient clinical research, specialized surgical care, and diagnostic practices." }
      ],
      topSectors: [
        { title: "Healthcare & Outpatient Care", desc: "Specialty medical offices, physical therapy, and dental practices." }
      ],
      majorInstitutions: ["University of Mississippi Medical Center (UMMC)", "Jackson State University"]
    }
  },

  // MISSOURI
  {
    id: "us-mo-jefferson-city",
    cityName: "Jefferson City",
    stateName: "Missouri",
    stateAbbreviation: "MO",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "missouri",
    citySlug: "jefferson-city-mo",
    lat: 38.5767,
    lng: -92.1735,
    supportedRadius: 15,
    dataCoverageScore: 88,
    businessCount: 260,
    relevantCategoryCount: 18,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["st-louis-mo", "kansas-city-mo"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Jefferson City Capital Area",
      localContextText: "Missouri's state capital center for state government relations, regulatory law, agriculture compliance, and administrative services.",
      majorDistricts: [
        { name: "Capitol Complex & High Street Legal Belt", desc: "Administrative law, regulatory consulting, state tax accounting, and lobbying." }
      ],
      topSectors: [
        { title: "State Administrative Law & Policy", desc: "Regulatory compliance practices, public policy consultancies, and tax accounting." }
      ],
      majorInstitutions: ["Lincoln University of Missouri"]
    }
  },

  // MONTANA
  {
    id: "us-mt-helena",
    cityName: "Helena",
    stateName: "Montana",
    stateAbbreviation: "MT",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "montana",
    citySlug: "helena-mt",
    lat: 46.5891,
    lng: -112.0391,
    supportedRadius: 15,
    dataCoverageScore: 87,
    businessCount: 220,
    relevantCategoryCount: 17,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["boise-id"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Helena Capital Region & Lewis and Clark County",
      localContextText: "Montana's state capital center for environmental law, public land policy, state administration, and outdoor resource technology.",
      majorDistricts: [
        { name: "State Capitol & Legal Quarter", desc: "Environmental law, land trust advisories, state regulatory compliance, and accounting." }
      ],
      topSectors: [
        { title: "Environmental & Public Land Law", desc: "Natural resource legal practices, water rights consultancies, and state compliance." }
      ],
      majorInstitutions: ["Carroll College"]
    }
  },

  // NEBRASKA
  {
    id: "us-ne-lincoln",
    cityName: "Lincoln",
    stateName: "Nebraska",
    stateAbbreviation: "NE",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "nebraska",
    citySlug: "lincoln-ne",
    lat: 40.8136,
    lng: -96.7026,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 520,
    relevantCategoryCount: 23,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["des-moines-ia", "denver-co"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Lincoln Capital Region & Nebraska Innovation Campus",
      localContextText: "Nebraska's state capital features agricultural technology research, insurance technology, state administration, and software engineering.",
      majorDistricts: [
        { name: "Nebraska Innovation Campus (NIC)", desc: "Agritech research labs, precision irrigation technology, food science, and software." }
      ],
      topSectors: [
        { title: "Agricultural Science & Precision Tech", desc: "Crop sensors, irrigation robotics, agritech software, and food safety." }
      ],
      majorInstitutions: ["University of Nebraska-Lincoln (UNL)"]
    }
  },

  // NEVADA
  {
    id: "us-nv-carson-city",
    cityName: "Carson City",
    stateName: "Nevada",
    stateAbbreviation: "NV",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "nevada",
    citySlug: "carson-city-nv",
    lat: 39.1638,
    lng: -119.7674,
    supportedRadius: 15,
    dataCoverageScore: 88,
    businessCount: 250,
    relevantCategoryCount: 18,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["sacramento-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Carson City Capital Region & Tahoe Corridor",
      localContextText: "Nevada's state capital center for gaming regulation law, state taxation advisories, environmental research, and manufacturing.",
      majorDistricts: [
        { name: "State Capitol & Legal Complex", desc: "Gaming regulatory compliance, corporate tax law, public policy, and accounting." }
      ],
      topSectors: [
        { title: "Gaming Regulatory & Tax Law", desc: "State compliance advisories, gaming licensing law, and corporate accounting." }
      ],
      majorInstitutions: ["Western Nevada College"]
    }
  },

  // NEW HAMPSHIRE
  {
    id: "us-nh-concord",
    cityName: "Concord",
    stateName: "New Hampshire",
    stateAbbreviation: "NH",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "new-hampshire",
    citySlug: "concord-nh",
    lat: 43.2081,
    lng: -71.5376,
    supportedRadius: 15,
    dataCoverageScore: 88,
    businessCount: 270,
    relevantCategoryCount: 18,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["boston-ma"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Concord Capital Region & Merrimack Valley",
      localContextText: "New Hampshire's state capital center for state government, legal services, precision manufacturing, and environmental law.",
      majorDistricts: [
        { name: "State House & Main Street Legal District", desc: "Administrative law, regulatory compliance, corporate filing law, and tax practices." }
      ],
      topSectors: [
        { title: "Public Administration & Corporate Law", desc: "State tax advisories, administrative compliance, and legal practices." }
      ],
      majorInstitutions: ["UNH Franklin Pierce School of Law"]
    }
  },

  // NEW JERSEY
  {
    id: "us-nj-trenton",
    cityName: "Trenton",
    stateName: "New Jersey",
    stateAbbreviation: "NJ",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "new-jersey",
    citySlug: "trenton-nj",
    lat: 40.2206,
    lng: -74.7597,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 480,
    relevantCategoryCount: 22,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["philadelphia-pa", "new-york-city-ny"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Trenton Capital Region & Princeton BioTech Belt",
      localContextText: "New Jersey's state capital connects state regulatory policy with the Princeton pharmaceutical research corridor.",
      majorDistricts: [
        { name: "State House & Capitol Complex", desc: "Administrative law practices, regulatory compliance, public policy, and tax law." }
      ],
      topSectors: [
        { title: "Regulatory Law & Bio-Pharmaceuticals", desc: "Pharmaceutical compliance, environmental law, and corporate tax accounting." }
      ],
      majorInstitutions: ["Thomas Edison State University", "Princeton University"]
    }
  },

  // NEW MEXICO
  {
    id: "us-nm-santa-fe",
    cityName: "Santa Fe",
    stateName: "New Mexico",
    stateAbbreviation: "NM",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "new-mexico",
    citySlug: "santa-fe-nm",
    lat: 35.687,
    lng: -105.9378,
    supportedRadius: 20,
    dataCoverageScore: 90,
    businessCount: 390,
    relevantCategoryCount: 21,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["phoenix-az", "denver-co"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Santa Fe Capital Region & Los Alamos National Lab Belt",
      localContextText: "New Mexico's state capital connects state government policy, environmental law, architectural design, and nuclear physics research at Los Alamos.",
      majorDistricts: [
        { name: "State Capitol & Historic Plaza Legal Quarter", desc: "Environmental law, tribal law practices, administrative affairs, and accounting." }
      ],
      topSectors: [
        { title: "Environmental & Tribal Law", desc: "Natural resource legal consultancies, water law, and state compliance." }
      ],
      majorInstitutions: ["St. John's College Santa Fe"]
    }
  },

  // NEW YORK
  {
    id: "us-ny-albany",
    cityName: "Albany",
    stateName: "New York",
    stateAbbreviation: "NY",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "new-york",
    citySlug: "albany-ny",
    lat: 42.6526,
    lng: -73.7562,
    supportedRadius: 20,
    dataCoverageScore: 94,
    businessCount: 620,
    relevantCategoryCount: 25,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["new-york-city-ny", "boston-ma"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Albany Capital District & Tech Valley (NY CREATES)",
      localContextText: "New York's state capital is Tech Valley's semiconductor research hub (Albany NanoTech Complex), administrative law center, and healthcare capital.",
      majorDistricts: [
        { name: "Albany NanoTech Complex & NY CREATES", desc: "Semiconductor R&D, extreme ultraviolet lithography, chip design, and materials science." }
      ],
      topSectors: [
        { title: "Semiconductor Science & Nanoelectronics", desc: "Nanotechnology research, cleanroom engineering, and microchip packaging." }
      ],
      majorInstitutions: ["University at Albany (SUNY)", "Albany Medical College"]
    }
  },
  {
    id: "us-ny-new-york-city",
    cityName: "New York City",
    stateName: "New York",
    stateAbbreviation: "NY",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "new-york",
    citySlug: "new-york-city-ny",
    lat: 40.7128,
    lng: -74.006,
    supportedRadius: 30,
    dataCoverageScore: 99,
    businessCount: 1890,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["albany-ny", "philadelphia-pa"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "New York Metropolitan Area (Wall Street, Silicon Alley, Midtown Financial)",
      localContextText: "Global financial, legal, fintech, media tech, and fashion capital offering thousands of premier career opportunities.",
      majorDistricts: [
        { name: "Wall Street & FiDi", desc: "Investment banking, hedge funds, corporate law, securities litigation, and accounting." }
      ],
      topSectors: [
        { title: "Financial Engineering & Corporate Law", desc: "Investment advisories, M&A law, securities law, and fintech." }
      ],
      majorInstitutions: ["Columbia University", "NYU", "Cornell Tech"]
    }
  },

  // NORTH CAROLINA
  {
    id: "us-nc-raleigh",
    cityName: "Raleigh",
    stateName: "North Carolina",
    stateAbbreviation: "NC",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "north-carolina",
    citySlug: "raleigh-nc",
    lat: 35.7796,
    lng: -78.6382,
    supportedRadius: 25,
    dataCoverageScore: 98,
    businessCount: 1420,
    relevantCategoryCount: 33,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["charlotte-nc", "washington-dc"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Raleigh-Durham Research Triangle Park (RTP)",
      localContextText: "North Carolina's state capital anchors Research Triangle Park (RTP), America's premier hub for biotech, agricultural science, open-source software (Red Hat), and clinical research.",
      majorDistricts: [
        { name: "Research Triangle Park (RTP)", desc: "Gene therapy research, agricultural biotechnology, open-source software engineering, and clinical trials." }
      ],
      topSectors: [
        { title: "Biotechnology & Open-Source Software", desc: "Genomics research, clinical trial technology, enterprise Linux platforms, and agtech." }
      ],
      majorInstitutions: ["North Carolina State University (NC State)", "Duke University", "UNC Chapel Hill"]
    }
  },

  // NORTH DAKOTA
  {
    id: "us-nd-bismarck",
    cityName: "Bismarck",
    stateName: "North Dakota",
    stateAbbreviation: "ND",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "north-dakota",
    citySlug: "bismarck-nd",
    lat: 46.8083,
    lng: -100.7837,
    supportedRadius: 15,
    dataCoverageScore: 88,
    businessCount: 260,
    relevantCategoryCount: 18,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["minneapolis-mn"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Bismarck Capital Region & Bakken Energy Zone",
      localContextText: "North Dakota's state capital center for energy regulation policy, agricultural compliance, state government, and healthcare.",
      majorDistricts: [
        { name: "State Capitol & Energy Policy Corridor", desc: "Administrative law, oil and gas regulatory compliance, agricultural law, and accounting." }
      ],
      topSectors: [
        { title: "Energy Regulation & Agricultural Policy", desc: "Regulatory compliance consultancies, environmental law, and state taxation." }
      ],
      majorInstitutions: ["University of Mary"]
    }
  },

  // OHIO
  {
    id: "us-oh-columbus",
    cityName: "Columbus",
    stateName: "Ohio",
    stateAbbreviation: "OH",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "ohio",
    citySlug: "columbus-oh",
    lat: 39.9612,
    lng: -82.9988,
    supportedRadius: 25,
    dataCoverageScore: 98,
    businessCount: 1450,
    relevantCategoryCount: 33,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["cleveland-oh", "cincinnati-oh"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Columbus Metropolitan Area (Silicon Heartland Intel Mega-Fab, Easton Tech)",
      localContextText: "Ohio's state capital leads the Midwest in semiconductor fabrication (Intel Mega-Fab in New Albany), e-commerce logistics technology, fashion retail corporate headquarters, and health science research at OSU.",
      majorDistricts: [
        { name: "New Albany Silicon Heartland Mega-Fab Zone", desc: "Semiconductor manufacturing, microchip packaging, cleanroom design, and electrical trades." }
      ],
      topSectors: [
        { title: "Semiconductor Fabrication & Logistics Tech", desc: "Microelectronics engineering, automated warehousing, and cloud platforms." }
      ],
      majorInstitutions: ["The Ohio State University (OSU)"]
    }
  },

  // OKLAHOMA
  {
    id: "us-ok-oklahoma-city",
    cityName: "Oklahoma City",
    stateName: "Oklahoma",
    stateAbbreviation: "OK",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "oklahoma",
    citySlug: "oklahoma-city-ok",
    lat: 35.4676,
    lng: -97.5164,
    supportedRadius: 25,
    dataCoverageScore: 94,
    businessCount: 780,
    relevantCategoryCount: 27,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["dallas-tx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Oklahoma City & Innovation District",
      localContextText: "Oklahoma's state capital center for energy transition research, aerospace maintenance (Tinker AFB), bioscience research, and state administration.",
      majorDistricts: [
        { name: "OKC Innovation District & Stephenson Cancer Center", desc: "Oncology clinical trials, biotech software, specialized surgery, and health tech." }
      ],
      topSectors: [
        { title: "Aerospace Maintenance & Bioscience", desc: "Avionics servicing, oncology research labs, and environmental engineering." }
      ],
      majorInstitutions: ["University of Oklahoma Health Sciences Center (OUHSC)"]
    }
  },

  // OREGON
  {
    id: "us-or-salem",
    cityName: "Salem",
    stateName: "Oregon",
    stateAbbreviation: "OR",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "oregon",
    citySlug: "salem-or",
    lat: 44.9429,
    lng: -123.0351,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 420,
    relevantCategoryCount: 21,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["portland-or", "seattle-wa"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Salem Capital Region & Willamette Valley",
      localContextText: "Oregon's state capital center for state environmental policy, agricultural technology, timber resource law, and public administration.",
      majorDistricts: [
        { name: "State Capitol & Court Street Legal Belt", desc: "Environmental law, land use compliance, public affairs, and state tax accounting." }
      ],
      topSectors: [
        { title: "Environmental & Land Use Law", desc: "Forestry compliance consultancies, water resource law, and state administration." }
      ],
      majorInstitutions: ["Willamette University"]
    }
  },

  // PENNSYLVANIA
  {
    id: "us-pa-harrisburg",
    cityName: "Harrisburg",
    stateName: "Pennsylvania",
    stateAbbreviation: "PA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "pennsylvania",
    citySlug: "harrisburg-pa",
    lat: 40.2732,
    lng: -76.8867,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 490,
    relevantCategoryCount: 23,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["philadelphia-pa", "pittsburgh-pa"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Harrisburg Capital Region & Susquehanna Valley",
      localContextText: "Pennsylvania's state capital center for Commonwealth administrative law, logistics distribution, healthcare systems, and state tax policy.",
      majorDistricts: [
        { name: "Capitol Complex & Legal Core", desc: "Administrative law, regulatory compliance, public policy, and corporate tax accounting." }
      ],
      topSectors: [
        { title: "Public Administration & Regulatory Law", desc: "Commonwealth compliance, state tax advisories, and administrative legal practices." }
      ],
      majorInstitutions: ["Penn State Harrisburg"]
    }
  },

  // RHODE ISLAND
  {
    id: "us-ri-providence",
    cityName: "Providence",
    stateName: "Rhode Island",
    stateAbbreviation: "RI",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "rhode-island",
    citySlug: "providence-ri",
    lat: 41.824,
    lng: -71.4128,
    supportedRadius: 20,
    dataCoverageScore: 94,
    businessCount: 650,
    relevantCategoryCount: 26,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["boston-ma", "hartford-ct"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Providence & Knowledge District",
      localContextText: "Rhode Island's state capital features marine design technology, healthcare, digital design (RISD ecosystem), and corporate law.",
      majorDistricts: [
        { name: "Jewelry District Tech & Medical Core", desc: "Biomedical engineering, health IT labs, digital software agencies, and design." }
      ],
      topSectors: [
        { title: "Digital Design & Marine Engineering", desc: "UX design studios, marine architecture, software development, and health tech." }
      ],
      majorInstitutions: ["Brown University", "Rhode Island School of Design (RISD)"]
    }
  },

  // SOUTH CAROLINA
  {
    id: "us-sc-columbia",
    cityName: "Columbia",
    stateName: "South Carolina",
    stateAbbreviation: "SC",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "south-carolina",
    citySlug: "columbia-sc",
    lat: 34.0007,
    lng: -81.0348,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 540,
    relevantCategoryCount: 24,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["charlotte-nc", "atlanta-ga"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Columbia Capital Region & Innovista District",
      localContextText: "South Carolina's state capital center for state government affairs, risk management, hydrogen energy technology, and higher education.",
      majorDistricts: [
        { name: "Innovista Research District & USC Core", desc: "Future fuels research, public health analytics, software engineering, and legal practices." }
      ],
      topSectors: [
        { title: "Risk Management & Public Policy", desc: "State regulatory advisories, insurance compliance law, and tax accounting." }
      ],
      majorInstitutions: ["University of South Carolina (USC)"]
    }
  },

  // SOUTH DAKOTA
  {
    id: "us-sd-pierre",
    cityName: "Pierre",
    stateName: "South Dakota",
    stateAbbreviation: "SD",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "south-dakota",
    citySlug: "pierre-sd",
    lat: 44.3683,
    lng: -100.351,
    supportedRadius: 15,
    dataCoverageScore: 86,
    businessCount: 180,
    relevantCategoryCount: 15,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["minneapolis-mn"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Pierre Capital Area & Missouri River Basin",
      localContextText: "South Dakota's state capital center for trust law, state taxation policy, agricultural compliance, and public administration.",
      majorDistricts: [
        { name: "State Capitol & Trust Legal District", desc: "Trust law advisories, state administrative compliance, agricultural policy, and tax law." }
      ],
      topSectors: [
        { title: "Trust Legal Services & Agriculture Policy", desc: "South Dakota trust law practices, agricultural compliance, and accounting." }
      ],
      majorInstitutions: ["Oglala Lakota College Pierre"]
    }
  },

  // TENNESSEE
  {
    id: "us-tn-nashville",
    cityName: "Nashville",
    stateName: "Tennessee",
    stateAbbreviation: "TN",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "tennessee",
    citySlug: "nashville-tn",
    lat: 36.1627,
    lng: -86.7816,
    supportedRadius: 25,
    dataCoverageScore: 98,
    businessCount: 1510,
    relevantCategoryCount: 34,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["atlanta-ga", "birmingham-al"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Nashville (Healthcare Management Core, Music Row, Tech Hill)",
      localContextText: "Tennessee's state capital is America's healthcare management capital (HCA Healthcare ecosystem), music tech center, and rapid-growth software hub.",
      majorDistricts: [
        { name: "Vanderbilt University Medical Center & Health Core", desc: "Hospital management software, clinical research, specialty medicine, and diagnostics." }
      ],
      topSectors: [
        { title: "Healthcare Systems & Management Technology", desc: "Hospital administration platforms, health analytics, and outpatient practices." }
      ],
      majorInstitutions: ["Vanderbilt University", "Belmont University"]
    }
  },

  // TEXAS
  {
    id: "us-tx-austin",
    cityName: "Austin",
    stateName: "Texas",
    stateAbbreviation: "TX",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "texas",
    citySlug: "austin-tx",
    lat: 30.2672,
    lng: -97.7431,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1650,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["houston-tx", "dallas-tx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Austin (Silicon Hills, Domain Northland)",
      localContextText: "Texas' state capital leads the nation in semiconductor expansion (Samsung, Tesla), enterprise software, digital creative media, and clean energy.",
      majorDistricts: [
        { name: "Silicon Hills & The Domain Tech Core", desc: "Enterprise SaaS engineering, semiconductor design, hardware robotics, and AI." }
      ],
      topSectors: [
        { title: "Enterprise Software & Semiconductor R&D", desc: "Custom web development, cloud security, microchip testing, and AI." }
      ],
      majorInstitutions: ["The University of Texas at Austin (UT Austin)"]
    }
  },

  // UTAH
  {
    id: "us-ut-salt-lake-city",
    cityName: "Salt Lake City",
    stateName: "Utah",
    stateAbbreviation: "UT",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "utah",
    citySlug: "salt-lake-city-ut",
    lat: 40.7608,
    lng: -111.891,
    supportedRadius: 25,
    dataCoverageScore: 97,
    businessCount: 1290,
    relevantCategoryCount: 32,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["boise-id", "denver-co"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Salt Lake (Silicon Slopes Corridor)",
      localContextText: "Utah's state capital leads Silicon Slopes in enterprise SaaS software, fintech, outdoor equipment innovation, and medical research.",
      majorDistricts: [
        { name: "Silicon Slopes Software Corridor", desc: "SaaS platforms, cloud infrastructure, analytics tools, and mobile software." }
      ],
      topSectors: [
        { title: "Enterprise SaaS & Cloud Infrastructure", desc: "Software engineering shops, developer tooling, and cybersecurity." }
      ],
      majorInstitutions: ["The University of Utah (U of U)"]
    }
  },

  // VERMONT
  {
    id: "us-vt-montpelier",
    cityName: "Montpelier",
    stateName: "Vermont",
    stateAbbreviation: "VT",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "vermont",
    citySlug: "montpelier-vt",
    lat: 44.2601,
    lng: -72.5754,
    supportedRadius: 15,
    dataCoverageScore: 86,
    businessCount: 190,
    relevantCategoryCount: 15,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["boston-ma"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Montpelier Capital Area & Winooski River Valley",
      localContextText: "Vermont's state capital center for captive insurance legal services, environmental protection, state government, and sustainable energy policy.",
      majorDistricts: [
        { name: "State House & Captive Insurance Belt", desc: "Captive insurance consultancies, environmental law, administrative affairs, and tax law." }
      ],
      topSectors: [
        { title: "Captive Insurance & Environmental Policy", desc: "Captive insurance legal practices, water quality consultancies, and state compliance." }
      ],
      majorInstitutions: ["Vermont Law and Graduate School"]
    }
  },

  // VIRGINIA
  {
    id: "us-va-richmond",
    cityName: "Richmond",
    stateName: "Virginia",
    stateAbbreviation: "VA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "virginia",
    citySlug: "richmond-va",
    lat: 37.5407,
    lng: -77.436,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 910,
    relevantCategoryCount: 29,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["washington-dc"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Richmond Metropolitan Area & VCU Health District",
      localContextText: "Virginia's state capital leads in financial services (Federal Reserve Bank of Richmond), corporate law, health science research, and advertising tech.",
      majorDistricts: [
        { name: "Downtown Financial & Legal Quarter", desc: "Corporate law firms, administrative compliance, financial planning, and accounting." }
      ],
      topSectors: [
        { title: "Corporate Law & Public Policy", desc: "State regulatory compliance, tax advisories, and commercial litigation." }
      ],
      majorInstitutions: ["Virginia Commonwealth University (VCU)", "University of Richmond"]
    }
  },

  // WASHINGTON
  {
    id: "us-wa-olympia",
    cityName: "Olympia",
    stateName: "Washington",
    stateAbbreviation: "WA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "washington",
    citySlug: "olympia-wa",
    lat: 47.0379,
    lng: -122.9007,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 410,
    relevantCategoryCount: 21,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["seattle-wa", "portland-or"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Olympia Capital Region & South Puget Sound",
      localContextText: "Washington's state capital center for state environmental policy, timber resource law, shellfish aquaculture science, and public administration.",
      majorDistricts: [
        { name: "State Capitol Campus & Legal Belt", desc: "Environmental law, natural resource consultancies, administrative affairs, and tax practices." }
      ],
      topSectors: [
        { title: "Environmental & Forestry Policy", desc: "Public land compliance, water rights legal practices, and marine aquaculture research." }
      ],
      majorInstitutions: ["The Evergreen State College"]
    }
  },
  {
    id: "us-wa-seattle",
    cityName: "Seattle",
    stateName: "Washington",
    stateAbbreviation: "WA",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "washington",
    citySlug: "seattle-wa",
    lat: 47.6062,
    lng: -122.3321,
    supportedRadius: 30,
    dataCoverageScore: 99,
    businessCount: 1750,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["olympia-wa", "portland-or"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Seattle Metropolitan Area (South Lake Union, Pioneer Square)",
      localContextText: "Global cloud computing capital (AWS, Microsoft ecosystem), aerospace engineering, global health research (Gates Foundation), and ocean sciences.",
      majorDistricts: [
        { name: "South Lake Union Tech Core", desc: "Cloud computing engineering, AI research, digital marketing, and health tech." }
      ],
      topSectors: [
        { title: "Cloud Infrastructure & AI Software", desc: "SaaS architecture, DevOps consultancies, cybersecurity, and developer tools." }
      ],
      majorInstitutions: ["University of Washington (UW)"]
    }
  },

  // WEST VIRGINIA
  {
    id: "us-wv-charleston",
    cityName: "Charleston",
    stateName: "West Virginia",
    stateAbbreviation: "WV",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "west-virginia",
    citySlug: "charleston-wv",
    lat: 38.3498,
    lng: -81.6326,
    supportedRadius: 20,
    dataCoverageScore: 89,
    businessCount: 320,
    relevantCategoryCount: 19,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["pittsburgh-pa"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Charleston Capital Region & Kanawha Valley",
      localContextText: "West Virginia's state capital center for energy transition law, chemical manufacturing, healthcare systems, and state administrative policy.",
      majorDistricts: [
        { name: "Capitol Complex & Kanawha Boulevard Legal Core", desc: "Energy law practices, environmental regulation compliance, public affairs, and accounting." }
      ],
      topSectors: [
        { title: "Energy Law & Environmental Regulation", desc: "Resource compliance advisories, chemical industry legal practices, and state tax law." }
      ],
      majorInstitutions: ["University of Charleston"]
    }
  },

  // WISCONSIN
  {
    id: "us-wi-madison",
    cityName: "Madison",
    stateName: "Wisconsin",
    stateAbbreviation: "WI",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "wisconsin",
    citySlug: "madison-wi",
    lat: 43.0731,
    lng: -89.4012,
    supportedRadius: 25,
    dataCoverageScore: 97,
    businessCount: 1120,
    relevantCategoryCount: 30,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["chicago-il", "minneapolis-mn"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Madison (Capital & Epic Systems Health IT Belt)",
      localContextText: "Wisconsin's state capital leads in electronic health records technology (Epic Systems ecosystem), biotechnology, stem cell research, and state policy.",
      majorDistricts: [
        { name: "Capitol Square & University Avenue Tech Belt", desc: "Health IT software engineering, stem cell research labs, bio-manufacturing, and legal practices." }
      ],
      topSectors: [
        { title: "Health IT & Biotechnology", desc: "Electronic health record software, clinical diagnostic labs, and bio-engineering." }
      ],
      majorInstitutions: ["University of Wisconsin-Madison (UW-Madison)"]
    }
  },

  // WYOMING
  {
    id: "us-wy-cheyenne",
    cityName: "Cheyenne",
    stateName: "Wyoming",
    stateAbbreviation: "WY",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "wyoming",
    citySlug: "cheyenne-wy",
    lat: 41.1399,
    lng: -104.8202,
    supportedRadius: 20,
    dataCoverageScore: 89,
    businessCount: 290,
    relevantCategoryCount: 19,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["denver-co"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Cheyenne Capital Region & F.E. Warren AFB Zone",
      localContextText: "Wyoming's state capital center for corporate LLC trust law, energy policy, defense technology, and cloud data center infrastructure.",
      majorDistricts: [
        { name: "State Capitol & Corporate Legal District", desc: "Wyoming corporate law, trust formation, state tax compliance, and administrative affairs." }
      ],
      topSectors: [
        { title: "Corporate Entity Law & Trust Services", desc: "LLC structure legal advisories, asset protection law, and tax compliance." }
      ],
      majorInstitutions: ["Laramie County Community College"]
    }
  },

  // WASHINGTON DC
  {
    id: "us-dc-washington",
    cityName: "Washington",
    stateName: "District of Columbia",
    stateAbbreviation: "DC",
    countryName: "United States",
    countryCode: "US",
    countrySlug: "united-states",
    regionSlug: "district-of-columbia",
    citySlug: "washington-dc",
    lat: 38.9072,
    lng: -77.0369,
    supportedRadius: 25,
    dataCoverageScore: 99,
    businessCount: 1680,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["annapolis-md", "richmond-va"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Washington DC Metropolitan Area (K Street, Navy Yard)",
      localContextText: "The nation's capital is a global center for administrative law, public policy, defense technology, cybersecurity, healthcare, and international development.",
      majorDistricts: [
        { name: "K Street & Downtown Legal District", desc: "Administrative law practices, regulatory compliance, public affairs, and lobbying." }
      ],
      topSectors: [
        { title: "Regulatory Law & Public Policy", desc: "Federal compliance practices, international law advisories, and tax accounting." }
      ],
      majorInstitutions: ["Georgetown University", "George Washington University (GWU)"]
    }
  }
];
